<template>
  <div class="restaurant-card">
    <img :src="getCardImage(index)" alt="Restaurant Image" class="restaurant-image" />
    <div class="restaurant-info">
      <h3 class="restaurant-name">{{ card.text }}</h3>
      <v-btn color="#337b52" @click="viewPdf(card.link)" class="menu-button" variant="outlined">
        {{ card.linkText }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "RestaurantCard",
  props: {
    card: Object,
    index: Number,
    getCardImage: Function,
    viewPdf: Function
  }
};
</script>

<style scoped>
.restaurant-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
  transition: transform 0.2s ease;
}

.restaurant-card:hover {
  transform: translateY(-4px);
}

.restaurant-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

.restaurant-info {
  padding: 16px;
  text-align: center;
}

.restaurant-name {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.menu-button {
  text-transform: none;
  font-weight: 500;
}

@media (max-width: 600px) {
  .restaurant-image {
    height: 150px;
  }

  .restaurant-name {
    font-size: 16px;
  }
}
</style>
